import { useEffect, useState } from 'react';

export default function ReportQuestionModal({ open, onClose, onSubmit, submitting = false }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (!open) return undefined;

    const handleEscape = (event) => {
      if (event.key === 'Escape' && !submitting) onClose();
    };

    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [open, onClose, submitting]);

  useEffect(() => {
    if (!open) {
      setTitle('');
      setDescription('');
    }
  }, [open]);

  if (!open) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!title.trim() || !description.trim() || submitting) return;
    await onSubmit?.({ title: title.trim(), description: description.trim() });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-[2px]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="report-question-title"
      onClick={submitting ? undefined : onClose}
    >
      <div
        className="relative w-full max-w-[420px] rounded-3xl bg-white p-6 shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="report-question-title" className="text-xl font-bold text-[#1B1B1B]">
          Report Question
        </h2>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label htmlFor="report-title" className="mb-2 block text-sm font-medium text-[#1B1B1B]">
              Title
            </label>
            <input
              id="report-title"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
              placeholder="Inappropriate content"
              disabled={submitting}
              className="w-full rounded-xl border border-[#D9D9D9] px-4 py-3 text-sm outline-none focus:border-[#9369CC] focus:ring-1 focus:ring-[#9369CC]"
            />
          </div>

          <div>
            <label
              htmlFor="report-description"
              className="mb-2 block text-sm font-medium text-[#1B1B1B]"
            >
              Description
            </label>
            <textarea
              id="report-description"
              value={description}
              onChange={(event) => setDescription(event.target.value)}
              placeholder="Describe the issue..."
              rows={5}
              disabled={submitting}
              className="w-full resize-none rounded-xl border border-[#D9D9D9] px-4 py-3 text-sm outline-none focus:border-[#9369CC] focus:ring-1 focus:ring-[#9369CC]"
            />
          </div>

          <div className="flex gap-4 pt-2">
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              className="w-full rounded-full border border-[#666666] px-6 py-2.5 text-sm font-semibold text-[#666666]"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!title.trim() || !description.trim() || submitting}
              className="w-full rounded-full bg-[#9369CC] px-6 py-2.5 text-sm font-semibold text-white disabled:opacity-50"
            >
              {submitting ? 'Submitting...' : 'Submit Report'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
